export default function TopMessageV2Skeleton() {
  return (
    <div className="box-border w-full h-[76px]">
      <div className="skeleton bg-surface-200-bg w-full h-full"></div>
    </div>
  );
}
